import GatewayAsset from './AccountGatewayAsset.vue';
import { createAccountPaymentGatewayModal } from './account-payment-gateway-modal';

export function createAccountPaymentGateways(LegacySettings, services) {
  if (!LegacySettings || !LegacySettings.components || !LegacySettings.components.PaymentGateway) return LegacySettings;
  return {
    extends: LegacySettings,
    components: {
      ...LegacySettings.components,
      GatewayAsset,
      PaymentGateway: createAccountPaymentGatewayModal(LegacySettings.components.PaymentGateway, services),
    },
  };
}
